export const getFeatures = ({ features }) => features.list.data;

export const getIsLoading = ({ features }) => features.list.isLoading;
